import { render, staticRenderFns } from "./NewCcsqd.vue?vue&type=template&id=4d889069&scoped=true&"
import script from "./NewCcsqd.vue?vue&type=script&lang=js&"
export * from "./NewCcsqd.vue?vue&type=script&lang=js&"
import style0 from "./NewCcsqd.vue?vue&type=style&index=0&id=4d889069&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d889069",
  null
  
)

export default component.exports